import { apiClient } from './client';
import { BoondSearchResult } from '@gridwise/shared';

export async function globalSearch(
  q: string,
  types?: string[],
): Promise<BoondSearchResult[]> {
  const response = await apiClient.get('/search', {
    params: { q, types: types?.join(',') },
  });
  return response.data.data;
}

export async function searchCompanies(q: string) {
  const response = await apiClient.get('/search/companies', { params: { q } });
  return response.data.data;
}

export async function searchContacts(q: string) {
  const response = await apiClient.get('/search/contacts', { params: { q } });
  return response.data.data;
}
